
import BaseAlert from "@/components/base/BaseAlert.vue";
import BaseSpinner from "@/components/base/BaseSpinner.vue";
import BookingHeader from "@/components/bookingflow/BookingHeader.vue";
import BookingExtra from "@/components/bookingflow/steps/extras/BookingExtra.vue";
import useAuth from "@/composables/useAuth";
import useCalculatePriceEffect from "@/composables/useCalculatePriceEffect";
import useExtras, { extrasComponents } from "@/composables/useExtras";
import { computed, defineComponent, onMounted, ref } from "vue";

export default defineComponent({
	components: {
		BookingHeader,
		BookingExtra,
		BaseSpinner,
		BaseAlert,
	},
	setup() {
		const { getExtras } = useExtras();
		const { initializeRedirect } = useAuth();
		useCalculatePriceEffect();
		
		const loading = ref<boolean>(false);
		const error = ref("");
		const components = computed(() => {
			return extrasComponents.value;
		});

		onMounted(() => {
			loading.value = true;
			getExtras()
				.catch((err) => {
					error.value = err.message;
					if (err?.response?.status === 405) {
						initializeRedirect();
					}
				})
				.finally(() => (loading.value = false));
		});
		return { components, loading, error };
	},
});
